import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory();

/** アクセスURL設定アクションクリエータ */
export const setAccessURL = actionCreator<{
	accessURL: string;
}>('SET_ACCESS_URL');



// WEBPACK FOOTER //
// ./src/actions/loginSso.ts